import { render } from "./System-Children.vue?vue&type=template&id=cffc58b8&scoped=true"
import script from "./System-Children.vue?vue&type=script&lang=js"
export * from "./System-Children.vue?vue&type=script&lang=js"

import "./System-Children.vue?vue&type=style&index=0&id=cffc58b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cffc58b8"]])

export default __exports__